import React, { useState } from "react";
import LoadingDots from "../../../../../global/LoadingDots";
import UploadIcon from "../../../../../global/icons/UploadIcon";
import { Button } from "@mui/material";
import DoneIcon from "../../../../../global/icons/DoneIcon";
import { useAuth } from "../../../../../../hooks/useAuth";
import {
  sendLeadToZapier,
  buildLeadData,
  leadTypeEnum,
} from "../../../../../../utils/zapier";
import { apiInstance } from "../../../../../../services/api.service";
import { generateUniqueFilename } from "utils/common";
import { NOTIFICATION_ENTITY } from "constants/common";
import toast from "react-hot-toast";
import { useEntityContext } from "context/EntityContext";

function FundsBuy({ companyId }) {
  const { user } = useAuth();
  const { entityId } = useEntityContext();
  //== FileUpload - START ==
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    setSelectedFile(file);
  };

  const handleFileUpload = async () => {
    if (selectedFile) {
      setUploading(true);

      const formData = new FormData();
      const fileName = generateUniqueFilename(selectedFile.name);

      formData.append("companyId", companyId);
      formData.append("file", selectedFile);
      formData.append("fileName", fileName);
      formData.append("entityModel", NOTIFICATION_ENTITY.UserWalletBuy);
      if (entityId) {
        formData.append("entityId", entityId);
      }
      formData.append("step", 3);

      try {
        await apiInstance.post("/api/docs/user/upload", formData);

        handleZapier(fileName);

        setUploaded(true);
        toast.success("File uploaded successfully!");
        setSelectedFile(null);
      } catch (error) {
        console.error("Error uploading file:", error);
        toast.error("File upload failed!");
        // Handle upload error
      } finally {
        setUploading(false);
      }
    }
  };

  const handleAnotherFileClick = () => {
    setSelectedFile(null);
    setUploaded(false);
    setUploading(false);
  };
  //== FileUpload - END ==

  //== Zapier - START ==
  const handleZapier = async (fileName) => {
    const leadContent = {
      dashboardType: "buy",
      userId: user.id,
      companyId: companyId,
      step: 3,
      fileName: fileName,
      phone: user?.phone || "",
    };
    const leadData = buildLeadData(leadTypeEnum.StocksBuy, leadContent);
    await sendLeadToZapier(leadData);
  };
  //== Zapier - START ==

  return (
    <>
      <div>Our finance department will approve the receipt of the funds.</div>
      <div className="separatorEmptyLarge"></div>
      <div className="separatorEmptyLarge"></div>

      <div className="containerFlex">
        <strong>We are almost there, waiting for funds confirmation</strong>
        <div className="separatorVerticalEmptyVerySmall"></div>
        <LoadingDots />
      </div>

      <div className="separatorEmptyLarge"></div>
      <div className="separatorEmptyLarge"></div>

      <div
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        className="dragBorder textAlignCenter"
      >
        <input
          type="file"
          id="fileInput"
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
        <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
          <UploadIcon />
          <div>
            Drag <strong>funds confirmation file</strong> to upload
          </div>
          <div className="fontGray">OR</div>
          <div className="orangeFont fontUnderline">Choose file</div>
        </label>
        <>
          {Boolean(selectedFile) && (
            <div className="containerFlex flexCenterHorizontally">
              <div>{uploaded ? <DoneIcon /> : <UploadIcon />}</div>
              <div className="separatorVerticalEmptySuperSmall"></div>
              <strong className="fontGray fontUnderline">
                {selectedFile.name}
              </strong>
            </div>
          )}
        </>
      </div>

      <div className="separatorEmptyLarge"></div>

      {!uploaded ? (
        <div className="containerFlex flexEnd">
          <Button
            variant="contained"
            color="orange"
            sx={{ textTransform: "none" }}
            style={{ borderRadius: 20 }}
            onClick={handleFileUpload}
            disabled={uploading || !selectedFile}
          >
            {uploading ? "Uploading..." : "Send The Funds Confirmation"}
          </Button>
        </div>
      ) : (
        <div
          className="containerFlex flexEnd linkDarkBlue"
          style={{ cursor: "pointer" }}
          onClick={handleAnotherFileClick}
        >
          <div className="fontUnderline">Upload Another File</div>
        </div>
      )}
    </>
  );
}

export default FundsBuy;
